export enum EntityType {
  Guest = 'Guest',
  Vehicle = 'Vehicle',
  Pet = 'Pet',
  Resident = 'Resident',
  AccessCard = 'AccessCard',
}

export enum Action {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
}

export const entityTypeMap: Record<EntityType, string> = {
  [EntityType.Guest]: 'Guest',
  [EntityType.Vehicle]: 'Vehicle',
  [EntityType.Pet]: 'Pet',
  [EntityType.Resident]: 'Resident',
  [EntityType.AccessCard]: 'AccessCard',
};

export const actionMap: Record<Action, string> = {
  [Action.Create]: 'Create',
  [Action.Update]: 'Update',
  [Action.Delete]: 'Delete',
};

export const entityTypeOptions = [
  { value: EntityType.Guest, label: entityTypeMap[EntityType.Guest] },
  { value: EntityType.Vehicle, label: entityTypeMap[EntityType.Vehicle] },
  { value: EntityType.Pet, label: entityTypeMap[EntityType.Pet] },
  { value: EntityType.Resident, label: entityTypeMap[EntityType.Resident] },
  { value: EntityType.AccessCard, label: entityTypeMap[EntityType.AccessCard] },
];

export const actionOptions = [
  { value: Action.Create, label: actionMap[Action.Create] },
  { value: Action.Update, label: actionMap[Action.Update] },
  { value: Action.Delete, label: actionMap[Action.Delete] },
];
